




















































































import { Inject, Component, Vue } from 'vue-property-decorator'
import { CompanyAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'

@Component
export default class CompanySettingsValuationSettings extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    loading: boolean = false
    valueLow: number = null
    valueBase: number = null
    valueHigh: number = null
    exampleValue: number = 355000

    async created() {
        await this.reload()
    }

    async reload() {
        this.loading = true
        this.valueLow = Number(Number((this.$currentCompany.valuationPercentageModifierLow * 100) - 100).toFixed(1))
        this.valueBase = Number(Number((this.$currentCompany.valuationPercentageModifierBase * 100) - 100).toFixed(1))
        this.valueHigh = Number(Number((this.$currentCompany.valuationPercentageModifierHigh * 100) - 100).toFixed(1))
        this.loading = false
    }

    async save() {
        try {
            this.loading = true
            await CompanyAPI.update(this.$currentCompany.id, {
                ...this.$currentCompany,
                valuationPercentageModifierLow: (this.valueLow + 100) / 100,
                valuationPercentageModifierBase: (this.valueBase + 100) / 100,
                valuationPercentageModifierHigh: (this.valueHigh + 100) / 100,
            } as Company)
            await this.reloadCompany()
            await this.reload()

        } finally {
            this.loading = false
        }
    }

    calculateExampleValue(percentageModifier: number, round: number = 100): number {
        const percentage = (percentageModifier + 100) / 100

        if (percentage < 1) {
            return Math.floor(this.exampleValue * percentage / round) * round
        } else if (percentage > 1) {
            return Math.ceil(this.exampleValue * percentage / round) * round
        } else {
            return Math.round(this.exampleValue / round) * round
        }
    }

    formatExampleValue(exampleValue: number): string {
        return exampleValue.toLocaleString('nl', { maximumFractionDigits: 0, style: 'currency', currency: 'EUR' })
    }
}
